export class UnreachableError extends Error {
  readonly value: unknown;

  constructor(value: unknown) {
    super(`Unreachable case: ${value}`);
    this.value = value;
    this.name = 'UnreachableError';
  }
}
